import { useEffect } from "react";
import { useLocation } from "@reach/router";
import { useRecoilValue } from "recoil";
import { langState } from "./recoilAtom";
import { getPageTitle } from "../data/pageTitles";

/**
 * Utrzymuje tytul karty przegladarki w zgodzie z aktualna strona i jezykiem.
 *
 * Statyczny <title> wstawia onRenderBody() w gatsby-ssr.tsx (wersja angielska --
 * taka trafia do robotow i do HTML-a serwowanego wszystkim). Po stronie klienta
 * tytul przejmuje ten hook: reaguje zarowno na zmiane sciezki, jak i na
 * przelaczenie jezyka w naglowku.
 *
 * Swiadomie nie korzystamy z Gatsby Head API -- komponent Head renderuje sie
 * poza RecoilRoot, wiec nie zna wybranego jezyka, a jego efekt nadpisywalby
 * ustawiony tu tytul przy kazdej nawigacji.
 */
const useDocumentTitle = (): void => {
  const lang = useRecoilValue(langState);
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = getPageTitle(pathname, lang);
  }, [pathname, lang]);
};

export default useDocumentTitle;
